import { requestFirebaseNotificationPermission } from '../../FCMToken'
import { toastSuccess } from '../../redux/slices/other.slice'
import { headers, checktoken } from '../../utils/helper'
import { addAuth } from '../../redux/slices/auth.slice'
import { Outlet, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Fragment, useEffect, useMemo } from 'react'
import { onMessage } from 'firebase/messaging'
import { messaging } from '../../firebase'
import { Cookies } from 'react-cookie'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import axios from "axios"

const PartnerLayout = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const cookies = new Cookies();
    const cookie = cookies.get('auth')
    const { hover } = useSelector(state => state.SidebarSlice)
    const { data: user } = useSelector(state => state.AuthSlice)
    const { data: sidebar } = useSelector(state => state.SidebarSlice)

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(`${process.env.REACT_APP_API_URL}/admin/partner/verify`, {
            headers: headers()
        }).then((res) => {
            if (res.data?.success === true) {
                dispatch(addAuth(res.data.data))
                if (res.data?.data === 'user' && (res.data?.data !== 'partner') && cookie !== null && cookie !== undefined) {
                    return true;
                } else {

                }
            }
        }).catch((err) => {
            checktoken(err);
        })
        requestFirebaseNotificationPermission()
        //eslint-disable-next-line
    }, [cookie, navigate]);

    useEffect(() => {
        const unsubscribe = onMessage(messaging, (payload) => {
            // ✅ Show custom notification
            if (Notification.permission === "granted") {
                dispatch(toastSuccess(`🔔 ${payload?.notification?.title} \n\n ${payload?.notification?.body}`));
            }
        });

        return () => unsubscribe();
    }, []);

    useMemo(() => {
        return sidebar
    }, [sidebar])

    return (
        <Fragment>
            <div className={`wrapper ${sidebar && 'toggled'} ${hover && 'sidebar-hovered'}`} >
                <Sidebar user={user} />
                <Header user={user} />
                <div className="page-wrapper">
                    <div className="page-content">
                        <Outlet context={[user]} />
                    </div>
                </div>
                <div className="overlay toggle-icon"></div>
                <a type="button" className="back-to-top"><i className='bx bxs-up-arrow-alt'></i></a>
                <Footer />
            </div>
        </Fragment>
    )
}

export default PartnerLayout;